import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=43882de6&scoped=true&lang=pug&"
import script from "./Question.vue?vue&type=script&lang=ts&"
export * from "./Question.vue?vue&type=script&lang=ts&"
import style0 from "./Question.vue?vue&type=style&index=0&id=43882de6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43882de6",
  null
  
)

export default component.exports